function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import * as IconsComponents from '@dtsl/icons/dist/icons/react';
const IconComponent = props => {
  const {
    value = 'AlertCircle',
    size = 16,
    className = '',
    ...restProps
  } = props;
  const Icon = IconsComponents[value];
  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: size,
    height: size,
    className: className
  }, restProps));
};
const MemoIconComponent = /*#__PURE__*/React.memo(IconComponent);
MemoIconComponent.displayName = 'IconComponent';
IconComponent.propTypes = {
  value: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
};
export default IconComponent;